import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GameProvider, GameContext } from "./GameContext";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GameProvider>
    <App />
  </GameProvider>
);
Storage.prototype.push = function (key, data) {
  // 取得現有的資料，若不存在則回傳空陣列
  const existingData = JSON.parse(this.getItem(key) || "[]");

  // 將新資料加到陣列尾端
  existingData.push(data);

  // 儲存更新後的資料到 localStorage 中
  this.setItem(key, JSON.stringify(existingData));
};
Date.prototype.formatYYYYMMDDHHMM = function () {
  if (isNaN(this.getTime())) {
    return ""; // 如果日期無效，返回空字符串
  }
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, '0');
  const day = String(this.getDate()).padStart(2, '0');
  const hours = String(this.getHours()).padStart(2, '0');
  const minutes = String(this.getMinutes()).padStart(2, '0');

  return `${year}.${month}.${day} ${hours}:${minutes}`;
};

Date.prototype.formatYYYYMMDD = function () {
  if (isNaN(this.getTime())) {
    return ""; // 如果日期無效，返回空字符串
  }
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, '0');
  const day = String(this.getDate()).padStart(2, '0');

  return `${year}年${month}月${day}日`;
};

Date.prototype.formatYYYYMMDD2 = function () {
  if (isNaN(this.getTime())) {
    return ""; // 如果日期無效，返回空字符串
  }
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, '0');
  const day = String(this.getDate()).padStart(2, '0');

  return `${year}.${month}.${day}`;
};
Date.prototype.formatYYYYMMDD3 = function () {
  if (isNaN(this.getTime())) {
    return ""; // 如果日期無效，返回空字符串
  }
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, '0');
  const day = String(this.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
};
Number.prototype.toMS = function (x) {
  const ms = this;
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return formattedTime;
};

Number.prototype.toZH = function () {
  const numMap = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
  const num = this.valueOf();

  if (num >= 0 && num <= 10) {
    return numMap[num];
  }

  return '範圍僅支持0到10';
};

Date.prototype.toZH = function () {
  const chineseMonths = [
    "一月", "二月", "三月", "四月", "五月", "六月",
    "七月", "八月", "九月", "十月", "十一月", "十二月"
  ];

  const month = chineseMonths[this.getMonth()];
  const day = this.getDate();

  return { month, day };
};

String.prototype.format = function () {
  var val1 = arguments;
  return this.replace(/{(\d+)}/g, function (get, number) {
    return typeof val1[number] != "undefined" ? val1[number] : get;
  });
};

function ColoredText({ color, fontWeight, text }) {
  return <span style={{ color, fontWeight }}>{text}</span>;
}

String.prototype.formatWithColor = function () {
  const values = [...arguments];
  let startIndex = 0;
  return (
    <>
      {this.split(/({\d+})/g).map((part, index) => {
        if (/\d+/.test(part)) {
          const valueIndex = parseInt(part.match(/\d+/)[0], 10);
          const value = values[valueIndex];
          startIndex += part.length;
          if (typeof value === "object") {
            return (
              <ColoredText
                color={value.color}
                text={value.str}
                key={startIndex}
                fontWeight={value.fw}
              />
            );
          } else {
            return (
              <ColoredText color="black" text={value} key={startIndex} />
            );
          }
        } else {
          startIndex += part.length;
          return <span key={startIndex}>{part}</span>;
        }
      })}
    </>
  );
};
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
